<template>
    <el-dialog
        :title="$t('common.change_password')"
        :visible.sync="visible_inline"
        width="480px"
    >
        <div slot="title">
            <div class="text-left truncate w-4/5 text-base font-semibold">
                {{ $t('common.change_password') }}
            </div>
        </div>

        <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
            <el-form-item
                :label="$t('common.old_password')"
                prop="current_password"
            >
                <el-input
                    v-model="ruleForm.current_password"
                    size="small"
                    autocomplete="none"
                    type="password"
                    :placeholder="$t('common.old_password')"
                />
            </el-form-item>

            <el-form-item
                class="mt-4"
                :label="$t('common.new_password')"
                prop="new_password"
            >
                <el-input
                    v-model="ruleForm.new_password"
                    size="small"
                    type="password"
                    :placeholder="$t('common.new_password')"
                />
            </el-form-item>

            <el-form-item
                class="mt-4"
                :label="$t('common.confirm_password')"
                prop="confirm_password"
            >
                <el-input
                    v-model="ruleForm.confirm_password"
                    size="small"
                    type="password"
                    :placeholder="$t('common.confirm_password')"
                />
            </el-form-item>
        </el-form>

        <div class="mt-4 flex justify-end">
            <el-button size="small" @click="visible_inline = false">
                {{ $t('button.close') }}
            </el-button>
            <el-button
                size="small"
                type="primary"
                icon="el-icon-check"
                @click="submitForm('ruleForm')"
            >
                {{ $t('common.change_password') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { changePassword } from '@/services/atosa/auth'

export default {
    props: ['visible'],

    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Hãy điền thông tin'))
            } else {
                if (this.ruleForm.confirm_password !== '') {
                    this.$refs.ruleForm.validateField('checkPass')
                }
                callback()
            }
        }

        const validateConfirmPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Hãy điền thông tin'))
            } else if (value !== this.ruleForm.new_password) {
                callback(new Error('Mật khẩu không trùng nhau'))
            } else {
                callback()
            }
        }

        return {
            ruleForm: {
                current_password: '',
                new_password: '',
                confirm_password: ''
            },
            rules: {
                current_password: [
                    {
                        required: true,
                        message: 'Hãy điền thông tin',
                        trigger: 'blur'
                    },
                    {
                        min: 6,
                        max: 32,
                        message: 'Độ dài dài từ 6 đến 36 kí tự',
                        trigger: 'blur'
                    },
                    { validator: validatePass, trigger: 'blur' }
                ],
                new_password: [
                    {
                        required: true,
                        message: 'Hãy điền thông tin',
                        trigger: 'blur'
                    },
                    {
                        min: 6,
                        max: 32,
                        message: 'Độ dài dài từ 6 đến 36 kí tự',
                        trigger: 'blur'
                    },
                    { validator: validatePass, trigger: 'blur' }
                ],
                confirm_password: [
                    {
                        required: true,
                        message: 'Hãy điền thông tin',
                        trigger: 'blur'
                    },
                    {
                        min: 6,
                        max: 32,
                        message: 'Độ dài dài từ 6 đến 36 kí tự',
                        trigger: 'blur'
                    },
                    { validator: validateConfirmPass, trigger: 'blur' }
                ]
            }
        }
    },

    computed: {
        visible_inline: {
            get() {
                return this.visible
            },
            set(value) {
                this.$emit('update:visible', value)
            }
        }
    },

    watch: {
        visible_inline() {
            this.$refs['ruleForm']?.resetFields()
        }
    },

    methods: {
        async changePassword() {
            try {
                const response = await changePassword(this.ruleForm)

                if (response.data) {
                    this.p__showNotify(
                        'success',
                        this.$t('common.change_password_success')
                    )

                    this.visible = false
                }
            } catch (error) {
                console.error(error)
            }
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.changePassword()
                } else {
                    console.error('error submit!!')
                    return false
                }
            })
        },

        resetForm(formName) {
            this.$refs[formName]?.resetFields()
        }
    }
}
</script>
